import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';

import { createReducer } from 'utils/ReduxUtils';

import * as types from '../actionTypes';

/**
 * @typedef {{
 *   ui: {
 *     isOpen: boolean,
 *     loading: boolean,
 *   }
 * }} ReportIssuesReducer
 */
export default combineReducers({
  ui: combineReducers({
    loading: loading(types.CREATE_REPORT_ISSUE_REQUEST),
    isOpen: createReducer(false, {
      [types.OPEN_REPORT_ISSUE_MODAL]: () => true,
      [types.CLOSE_REPORT_ISSUE_MODAL]: () => false,
      [types.CREATE_REPORT_ISSUE_SUCCESS]: () => false,
    })
  })
});
